// app/javascript/packs/tickets.js

window.generateTableHTML = function (issues, includeCheckbox = false, sectionName = '', options = {}) {
  if (!Array.isArray(issues)) issues = []
  const isModal = options.isModal || false
  const isDeployedSection = options.isDeployedSection || false
  if (issues.length === 0) {
    return '<p class="text-center">No issues found.</p>'
  }

  function truncate(str, n) {
    if (!str) return ''
    return str.length > n ? str.slice(0, n - 1) + '…' : str
  }

  let html = `
    <div class="table-responsive sticky-table-container">
      <table class="table issues-table-section sticky-table" data-section="${sectionName}">
        <thead class="sticky-header">
          <tr>
            ${
              includeCheckbox && !isModal
                ? `<th><input type="checkbox" class="select-all-section" data-section="${sectionName}" /></th>`
                : ''
            }
            <th class="sortable" data-sort="identifier">Ticket</th>
            <th class="sortable" data-sort="branch">Branch</th>
            <th class="sortable" data-sort="app">App</th>
            <th class="sortable" data-sort="title">Title</th>
            <th class="sortable" data-sort="assignee">Assignee</th>
            <th>Deployment Notes</th>
            ${isModal ? '' : '<th class="sortable" data-sort="status">Status</th>'}
            <th>Link</th>
          </tr>
        </thead>
        <tbody>
  `

  issues.forEach(issue => {
    if (!issue) return
    let deploymentNotesCell
    if (!issue.deployment_notes || issue.deployment_notes === 'No deployment notes found') {
      deploymentNotesCell = '<span class="badge badge-missing-notes">No deployment<br>notes found!</span>'
    } else {
      deploymentNotesCell = truncate(issue.deployment_notes, isModal ? 30 : 200)
    }
    html += `
      <tr data-issue-id="${issue.id}">
        ${
          includeCheckbox && !isModal
            ? `<td><input type="checkbox" class="section-checkbox" data-section="${sectionName}" data-id="${issue.id}" value="${issue.id}" /></td>`
            : ''
        }
        <td>${issue.identifier || ''}</td>
        <td>${truncate(issue.branchName || 'N/A', isModal ? 16 : 100)}</td>
        <td>
          ${issue.is_missing_app_labels ? '<span class="badge badge-missing-notes">Missing Apps!</span>' : ''}
          ${window.renderAppBadges(issue.labels, isDeployedSection)}
        </td>
        <td>${truncate(issue.title || '', isModal ? 24 : 200)}</td>
        <td>${truncate(
          issue.assignee && issue.assignee.name ? issue.assignee.name : 'Unassigned',
          isModal ? 16 : 100
        )}</td>
        <td>${deploymentNotesCell}</td>
        ${isModal ? '' : `<td>${issue.state?.name || ''}</td>`}
        <td><a href="${issue.url || '#'}" target="_blank">View in Linear</a></td>
      </tr>
    `
  })

  html += `
        </tbody>
      </table>
    </div>
  `

  return html
}

// Section-based select-all logic
if (!window.sectionSelectAllHandlerAdded) {
  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('select-all-section')) {
      const section = e.target.dataset.section
      const checked = e.target.checked
      document.querySelectorAll(`.section-checkbox[data-section='${section}']`).forEach(cb => {
        cb.checked = checked
      })
    }
  })
  window.sectionSelectAllHandlerAdded = true
}

window.renderAppBadges = function (labels, isDeployedSection = false) {
  if (!labels || !Array.isArray(labels.nodes) || labels.nodes.length === 0) return 'No Label'

  return labels.nodes
    .filter(label => label && label.name)
    .map(label => {
      let badgeClass = ''
      if (['mf_store', 'mf_admin', 'mf_api_server'].includes(label.name)) {
        badgeClass = `badge-${label.name}`
      } else if (label.name?.toLowerCase().includes('checkout')) {
        badgeClass = 'badge-checkout'
      }
      if (isDeployedSection) badgeClass += ' badge-gray'
      return `<span class="badge ${badgeClass}">${label.name}</span>`
    })
    .join(' ')
}

window.renderLatestComment = function (comments) {
  if (!comments || !Array.isArray(comments.nodes) || comments.nodes.length === 0) return 'No comments'

  const lastComment = comments.nodes.find(node => node && node.body)
  if (!lastComment) return 'No comments'

  const createdAt = lastComment.createdAt ? new Date(lastComment.createdAt).toLocaleString() : ''
  return `
    <div class="markdown-content">
      ${lastComment.body}
      <small>${createdAt}</small>
    </div>
  `
}

window.setupSorting = function (table) {
  if (!table) return

  const headers = table.querySelectorAll('th.sortable')
  headers.forEach(header => {
    header.addEventListener('click', () => {
      const column = header.dataset.sort
      const isAscending = header.classList.contains('asc')

      headers.forEach(h => h.classList.remove('asc', 'desc'))
      header.classList.add(isAscending ? 'desc' : 'asc')

      const rows = Array.from(table.querySelectorAll('tbody tr'))
      const sortedRows = rows.sort((a, b) => {
        const aValue = a.querySelector(`td:nth-child(${Array.from(headers).indexOf(header) + 1})`).textContent.trim()
        const bValue = b.querySelector(`td:nth-child(${Array.from(headers).indexOf(header) + 1})`).textContent.trim()

        if (aValue < bValue) return isAscending ? -1 : 1
        if (aValue > bValue) return isAscending ? 1 : -1
        return 0
      })

      table.querySelector('tbody').innerHTML = ''
      sortedRows.forEach(row => table.querySelector('tbody').appendChild(row))
    })
  })
}

window.updateCount = function (state, count) {
  const countSpan = document.getElementById(`${state.toLowerCase().replace(/\s+/g, '-')}-count`)
  if (countSpan) {
    countSpan.textContent = ` (${count})`
  }
}

window.styleAppSections = function () {
  document.querySelectorAll('.app-header').forEach(header => {
    const app = header.dataset.app
    header.style.backgroundColor = window.appColors[app]

    const title = header.querySelector('.app-title')
    if (title) {
      title.style.color = 'white'
    }

    header.querySelectorAll('.btn-release').forEach(button => {
      button.style.backgroundColor = window.appColors[app]
      button.style.borderColor = 'white'
      button.style.borderWidth = '2px'
      button.style.borderStyle = 'solid'
      button.style.color = 'white'

      button.addEventListener('mouseenter', function () {
        this.style.backgroundColor = window.lightenColor(window.appColors[app], 0.1)
      })

      button.addEventListener('mouseleave', function () {
        this.style.backgroundColor = window.appColors[app]
      })
    })
  })
}

window.lightenColor = function (color, amount) {
  return (
    '#' +
    color
      .replace(/^#/, '')
      .replace(/../g, color =>
        ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount * 255)).toString(16)).substr(-2)
      )
  )
}

window.darkenColor = function (color, amount) {
  return (
    '#' +
    color
      .replace(/^#/, '')
      .replace(/../g, color =>
        ('0' + Math.min(255, Math.max(0, parseInt(color, 16) - amount * 255)).toString(16)).substr(-2)
      )
  )
}

window.appColors = {
  mf_api_server: '#8FBCBB',
  mf_admin: '#81a1c1',
  mf_store: '#D04648'
}

window.renderDeploymentNotes = function (comments) {
  if (!comments || !Array.isArray(comments.nodes) || comments.nodes.length === 0) return 'No deployment notes'

  for (let comment of comments.nodes) {
    if (!comment || !comment.body) continue
    const match = comment.body.match(/@deploymentNotes@([\s\S]*?)@@deploymentNotes@/)
    if (match) {
      return `
        <div class="deployment-notes">
          ${match[1].trim()}
        </div>
      `
    }
  }

  return 'No deployment notes found'
}

// Removed duplicate updateMainTable function - this is now handled in the HTML file

// Removed conflicting turbolinks:load event listener - this is now handled in the HTML file

// Removed problematic spinner line - spinner should be controlled by the HTML event listeners

const deploymentModal = document.getElementById('deploymentModal')
if (deploymentModal) {
  deploymentModal.addEventListener('hidden.bs.modal', function () {
    const spinner = document.getElementById('spinner')
    if (spinner) spinner.style.display = 'none'
  })
}
